import React from 'react';
import { useTranslation } from 'react-i18next';
import { shallowEqual, useSelector } from 'react-redux';

import { getPropertyInsuranceList } from '../../redux/modules/insurances';
import { tableDateFormat } from '../../helpers/dates';
import formatCurrency from '../../helpers/formatCurrency';
import InsurancesTable from './InsurancesTable';
import { INSURANCE_TYPES } from '../../constants';

const PropertyInsurancesTable = () => {
  const { t } = useTranslation();
  const { tblData, isLoading } = useSelector(
    (store) => store.insurances.propertyInsuranceList, shallowEqual,
  );

  const columns = [
    {
      title: 'insuranceList.contractNumber',
      property: 'masysId',
      sortable: true,
    },
    {
      title: 'insuranceList.from',
      property: 'contractStart',
      sortable: true,
      format: tableDateFormat,
    },
    {
      title: 'insuranceList.to',
      property: 'contractEnd',
      sortable: true,
      format: tableDateFormat,
    },
    {
      title: 'insuranceList.price',
      property: 'price',
      sortable: true,
      format: (v) => `${formatCurrency(v)} ${t('currency.AMD')}`,
    },
  ];

  return (
    <InsurancesTable
      type={INSURANCE_TYPES.PROPERTY}
      title="insuranceList.propertyInsurances"
      columns={columns}
      tblData={tblData}
      isLoading={isLoading}
      getInsuranceList={getPropertyInsuranceList}
    />
  );
};
export default PropertyInsurancesTable;
